<template>
    <v-container fluid grid-list-sm text-xs-left>

        <v-layout row wrap class="mb-4">
            <v-flex xs12 class="subheading">
                <span>The score is calculated by adding the values assigned to the startups for each field as represented in the following tables: </span>
            </v-flex>

        </v-layout>

        <v-layout row wrap>
            <v-flex pa-1 lg3 md6 sm6 xs12 v-for="field in fields">
                <v-card>
                    <v-card-title style="height: 75px" class="primary white--text subheading">{{field.title}}</v-card-title>
                    <v-card-text class="ma-0 pa-0">
                        <v-data-table
                                :headers="headers"
                                :items="field.values"
                                hide-actions
                        >
                            <template v-slot:items="props">
                                <td class="">{{ props.item.name }}</td>
                                <td class="">{{ props.item.score }}</td>

                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>

        </v-layout>

    </v-container>
</template>

<script>
    export default {
        name: "ScoreTables",
        components: {},
        props: [],
        data() {
            return {
                headers: [{
                    text: 'Name',
                    align: 'left',
                    sortable: false,
                    value: 'name',
                },
                    {
                        text: 'Score',
                        align: 'left',
                        sortable: true,
                        value: 'score',
                    },
                ],
                fields: [
                    {
                        title: "Replication complexity",
                        values: [
                            {name: "-", score: 0},
                            {name: "High", score: 2},
                            {name: "Low", score: 0},
                            {name: "Medium", score: 1},

                        ]
                    },
                    {
                        title: "Deployment complexity",
                        values: [
                            {name: "-", score: 0},
                            {name: "High", score: 0},
                            {name: "Low", score: 2},
                            {name: "Medium", score: 1},

                        ]
                    },
                    {
                        title: "Technological footprint",
                        values: [
                            {name: "-", score: 0},
                            {name: "High", score: 2},
                            {name: "Low", score: 0},
                            {name: "Medium", score: 1},

                        ]
                    },
                    {
                        title: "Business model",
                        values: [
                            {name: "-", score: 0},
                            {name: "B2B", score: 2},
                            {name: "B2B:B2C", score: 1},
                            {name: "B2C", score: 0},

                        ]
                    },
                    {
                        title: "Financial status (Startuplus, iCRIBIS)",
                        values: [
                            {name: "High", score: 2},
                            {name: "Low", score: 0},
                            {name: "Medium", score: 1},
                            {name: "Not Available", score: 0},
                            {name: "-", score: 0},

                        ]
                    },
                    {
                        title: "Patent",
                        values: [
                            {name: "-", score: 0},
                            {name: "n", score: 0},
                            {name: "pending", score: 0.5},
                            {name: "y", score: 1},

                        ]
                    },
                    {
                        title: "SDK/API",
                        values: [
                            {name: "-", score: 0},
                            {name: "n", score: 0},
                            {name: "y", score: 1},

                        ]
                    },
                    {
                        title: "Existing Partnerships/Exclusivity (non-VC's)",
                        values: [
                            {name: "-", score: 0},
                            {name: "n", score: 0},
                            {name: "y", score: 1},

                        ]
                    },

                    {
                        title: "Extensive business enabler",
                        values: [
                            {name: "-", score: 0},
                            {name: "n", score: 0},
                            {name: "y", score: 1},

                        ]
                    },
                    {
                        title: "Funding status (CrunchBase)",
                        values: [
                            {name: "Grant", score: 1},
                            {name: "IPO", score: 7},
                            {name: "Seed", score: 1},
                            {name: "Series A", score: 2},
                            {name: "Series B", score: 3},
                            {name: "Series C", score: 4},
                            {name: "Series D", score: 5},
                            {name: "Series E", score: 6},

                        ]
                    },
                    {
                        title: "Funding status (CrunchBase)",
                        values: [
                            {name: "Convertible note", score: 1},
                            {name: "Corporate round", score: 1},
                            {name: "Early stage venture", score: 2},
                            {name: "N/A", score: 0},
                            {name: "Non-equity Assistance", score: 1},
                            {name: "Not available", score: 0},
                            {name: "Venture - Series Unknown", score: 2},
                            {name: "Own funding", score: 0.5},
                            {name: "-", score: 0},

                        ]
                    },
                    {
                        title: "Idea State",
                        values: [
                            {name: "First customers", score: 4},
                            {name: "Idea", score: 0},
                            {name: "On the market", score: 3},
                            {name: "Product", score: 3},
                            {name: "Prototype/beta version", score: 1},
                            //{name: "Ready", score: 2},
                            {name: "-", score: 0},

                        ]
                    },
                ]

            }
        },

        methods: {
        },
    }
</script>

<style scoped>

</style>